// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }
  
  .filter-modal-background {
    width: 100%;
    height: 100%;
  }
  
  .filter-modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #ffffff;
    width: 80%;
    max-width: 600px;
    height: 80%;
    border-radius: 8px;
    overflow: auto;
  }
  
  .filter-modal-header {
    height: 112px;
    background-color: #5b7f95;
    display: flex;
    align-items: center;
    padding: 0 24px;
  }
  
  .back-button {
    color: white;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
  }
  
  .filter-modal-title {
    color: white;
    font-size: 20px;
    margin-left: auto;
  }
  
  .filter-modal-menu {
    padding: 24px;
  }
  
  .filter-modal-menu-item {
    margin-bottom: 16px;
    cursor: pointer;
  }
  
  .filter-modal-submenu {
    margin-left: 16px;
  }
  
  .filter-modal-submenu-item {
    margin-bottom: 8px;
  }
  `, "",{"version":3,"sources":["webpack://./src/css/FilterModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,yBAAyB;IACzB,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":[".filter-modal-container {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    z-index: 9999;\r\n  }\r\n  \r\n  .filter-modal-background {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  \r\n  .filter-modal {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    background-color: #ffffff;\r\n    width: 80%;\r\n    max-width: 600px;\r\n    height: 80%;\r\n    border-radius: 8px;\r\n    overflow: auto;\r\n  }\r\n  \r\n  .filter-modal-header {\r\n    height: 112px;\r\n    background-color: #5b7f95;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 24px;\r\n  }\r\n  \r\n  .back-button {\r\n    color: white;\r\n    background: none;\r\n    border: none;\r\n    cursor: pointer;\r\n    font-size: 16px;\r\n  }\r\n  \r\n  .filter-modal-title {\r\n    color: white;\r\n    font-size: 20px;\r\n    margin-left: auto;\r\n  }\r\n  \r\n  .filter-modal-menu {\r\n    padding: 24px;\r\n  }\r\n  \r\n  .filter-modal-menu-item {\r\n    margin-bottom: 16px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .filter-modal-submenu {\r\n    margin-left: 16px;\r\n  }\r\n  \r\n  .filter-modal-submenu-item {\r\n    margin-bottom: 8px;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
